import React, { useState, useEffect } from 'react';
import { useTheme, IconButton, TablePagination, Stack, Tooltip, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { CancelToken } from 'apisauce';
import * as moment from 'moment';
import { Box } from '@mui/system';

import TablePaginationActions from '../../../components/TablePaginationActions';
import PageHeader from '../../../components/PageHeader';
import appapi from '../../../api/apiClient';
import Datatable from '../../../components/DataTable';
import Layout from '../../../components/Layout';
import EnchanedTableHeader from '../../../components/EnchanedTableHeader';
import { RenderIf } from '../../../utils/customHooks';
import DragAndDrop from '../../../components/DragAndDrop/DragAndDrop';
import { setLoading } from '../../../redux/features/appSlice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { s3FilePathConverter } from '../../../utils/s3FilePathConverter';
import { checkPermission } from '../../../redux/features/authSlice';
import ViewTrader from './Components/ViewTrader';
import AddEditDialog from './Components/AddEditDialog';

export default function Trader() {
  function getColor(type) {
    if (type === '1') {
      return '#00A632';
    }
    if (type === '2') {
      return '#B11B1B';
    }
  }

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
    },
    {
      id: 1,
      header: 'Trader Name',
      accessor: 'traderName',
      width: '20%',
      search: false,
      capitalize: true,
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [
          {
            name: 'Sort A -> Z',
            id: 'asc',
          },
          {
            name: 'Sort Z -> A',
            id: 'desc',
          },
        ],
      },
    },
    {
      id: 2,
      header: 'State',
      accessor: 'stateName',
      width: '20%',
      capitalize: true,
    },
    {
      id: 3,
      header: 'Country',
      accessor: 'countryName',
      width: '20%',
      capitalize: true,
    },
    {
      id: 4,
      header: 'Status',
      accessor: 'status',
      width: '10%',
      filter: {
        search: false,
        filterType: 'RadioButton',
        typeFilter: true,
        filterList: [
          {
            name: 'Active',
            id: 1,
          },
          {
            name: 'Inactive',
            id: 2,
          },
        ],
      },
      Cell: (item) => (
        <Stack justifyContent="center">
          <Tooltip disableInteractive>
            <Stack
              style={{}}
              direction={'row'}
              alignItems={'center'}
            >
              <Stack style={{ height: '12px', width: '12px', borderRadius: '10px', backgroundColor: getColor(item?.status), marginRight: '5px' }}></Stack>
              <Typography
                style={{ color: getColor(item.status) }}
                className="ff-Roboto fw-regular fs-12"
              >
                {item.status === '1' ? 'Active' : 'Inactive'}
              </Typography>
            </Stack>
          </Tooltip>
        </Stack>
      ),
    },
    {
      id: 4,
      header: 'Action',
      accessor: 'action',
      width: '10%',
      Cell: (value) => (
        <Stack
          direction="row"
          justifyContent="center"
        >
          <Tooltip
            disableInteractive
            title="View"
          >
            <IconButton
              onClick={() => {
                setOpenViewTrader(true);
                setSelectedTrader(value);
              }}
            >
              <VisibilityIcon
                style={{
                  color: theme.palette.primary.light,
                  transform: 'scale(0.889)',
                }}
              />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];
  const theme = useTheme();
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    totalLength: 0,
    paginationPage: 0,
    status: 0,
    field: '_id',
    sortOrder: 'desc',
  });
  let source = CancelToken.source();
  const [type, setType] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [openViewTrader, setOpenViewTrader] = useState(false);
  const [openAddEdit, setOpenAddEdit] = useState(false);
  const [tradersList, setTradersList] = useState([]);
  const [selectedTrader, setSelectedTrader] = useState([]);
  const [customerManagementColumn, setCustomerManagementColumn] = useState(columns);

  const { user } = useSelector((state) => state.auth);

  const permission = useSelector((state) => checkPermission(state, 'Vehicle Details'));
  /**
   *
   *
   *
   * @function handleChangePage
   * @function handleChangeRowsPerPage
   * handle Pagination
   */
  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limt: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, filter: search }));
  };

  const getData = (event) => {
    if (event) {
    }
  };

  const handleGetTrader = async (fromSearch = true) => {
    setIsLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/trader/all`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        status: payload.status,
        field: payload.field,
        sortOrder: payload.sortOrder,
      },
      { cancelToken: source.token },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let userData = data?.response;
        userData.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
          return item;
        });
        setTradersList(userData);
        setPayload((prev) => ({ ...prev, totalLength: data?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setTradersList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 0 }));
        setIsLoading(false);
      }
    } else {
      setTradersList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0,  paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    handleGetTrader();
    return () => {
      if(source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page,  payload.filter, payload.status, payload.field, payload.sortOrder]);

  return (
    <>
      <Layout>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems={'inherit'}
        >
          <Stack className="w-[100%]">
            <PageHeader
              headerTittle={`Trader`}
              handleOnSearchEmit={(search) => {
                handleSearchEmit(search);
              }}
              placeholder={'Trader Name'}
              userPermission={''}
              handleExcelDownloadEmit={(value) => {}}
              handleOnAddEmit={(value) => {
                setOpenAddEdit(true);
              }}
              buttonShowPermission={{
                addItem: true,
              }}
            />
          </Stack>
          <Stack style={{ backgroundColor: '#FFFFFF' }}>
            <TablePagination
              rowsPerPageOptions={[]}
              count={payload.totalLength ? payload.totalLength : 0}
              rowsPerPage={payload.limit ? payload.limit : 10}
              page={payload.paginationPage ? payload.paginationPage : 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Stack>
        </Stack>
        <Box sx={{ width: '100%' }}>
          <Datatable
            data={tradersList || []}
            columns={customerManagementColumn}
            isLoading={isLoading}
            onChangeFilter={(filterValues) => {
              const columnUpdate = customerManagementColumn;
              columnUpdate[filterValues?.id].filter[`selectValue`] = filterValues?.filter.selectValue;
              setCustomerManagementColumn(columnUpdate);
              if (filterValues.accessor === 'traderName') {
                const sValue = filterValues?.filter.selectValue;
                const order = sValue ? sValue : 'desc';
                const field = sValue ? filterValues.accessor : '_id';

                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: field, sortOrder: order }));
              } else {
                setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, status: filterValues?.filter.selectValue || 0 }));
              }
            }}
            onChangeSort={(sortValues) => {
              const columnUpdate = [...customerManagementColumn];
              columnUpdate[sortValues?.id].sortOrder = sortValues.order;
              columnUpdate[sortValues?.id].sortActive = sortValues.sortActive;
              setCustomerManagementColumn([...columnUpdate]);
              setPayload((prevState) => ({ ...prevState, limt: 10, paginationPage: 0, page: 1, field: sortValues.accessor, sortOrder: sortValues.order }));
            }}
          />
        </Box>
      </Layout>
      {openViewTrader ? (
        <ViewTrader
          onModelHandleClose={(event) => {
            if (event) {
              handleGetTrader();
            }
            setOpenViewTrader(false);
          }}
          modelOpen={openViewTrader}
          traderId={selectedTrader?._id}
          refresh={() => handleGetTrader()}
        />
      ) : null}
      {openAddEdit ? (
        <AddEditDialog
          onModelHandleClose={(event) => {
            if (event) {
              handleGetTrader();
            }
            setOpenAddEdit(false);
          }}
          modelOpen={openAddEdit}
          // companyDetails={companyDetails}
        />
      ) : null}
    </>
  );
}
